<template>
  <section
    class="bt card-style"
    id="entity-users-list"
    v-loading="loading"
    :element-loading-text="loadingText"
  >
    <entity-content-view
      v-if="
        showFieldsParent && showFieldsParent.selected_email_template && formattedEntityData.length
      "
      @deleteEmail="deleteCheckedEntityData"
      :search_string="search_string"
      :selectedRowsIds="selectedRowsIds"
      :showFields="showFieldsParent"
      :isApplicationUserSide="isApplicationUserSide"
      :currentMenu="currentMenu"
      :getSelfEntityFilters="getSelfEntityFilters"
      :appliedQuickFilters="applied_quick_filters"
      :entityFiltersData="entityFiltersData"
      :data="formattedEntityData"
      :originalData="data"
      :allEmailTemplates="JSON.parse(JSON.stringify(allEmailTemplates))"
      :selectedEmailTemplate="getSelectedEmailTemplate()"
      :keyLabel="prepareKeyLabelsObject()"
      @SaveData="checkForFilterUpdate"
      @updateRow="updateRow"
      :quickUpdateRowData="quickUpdateRowData"
      :currentEntity="currentEntity"
      @quickUpdateDataProp="handleQuickUpdateData"
      :currentPage="currentPage"
      :total="total"
      @refreshCurrentPage="refreshCurrentPage"
      :allEntities="allEntitiesData"
    ></entity-content-view>

    <add-entity-reationship-data-widget
      v-if="showAddRelationshipDataDialog"
      :relationshipDetails="selectedRelationshipDetails"
      :existedData="selectedRelationshipExistedIds"
      :autoPopup="true"
      v-on:entityDataClosed="showAddRelationshipDataDialog = false"
    ></add-entity-reationship-data-widget>

    <ActionButtonExecute
      v-if="quickActionModal && quickActionDummyField"
      :data="quickActionDummyField"
      :isView="false"
      :entityId="currentEntity._id"
      :entityDataId="quickActionDummyField.parent_entityDataId"
      :fromQuickAction="true"
      :entityData="rowEntityData"
      :selfTemplateId="quickActionDummyField.template_id"
      :allEntitiesData="allEntitiesData"
      :allEntityFields="allEntityFields"
      :form="quickActionDummyForm"
      @closeModal="quickActionModal = false"
    ></ActionButtonExecute>

    <el-pagination
      v-if="!refreshPage"
      :data="this.data"
      :search_string="search_string"
      :class="'custom-pagination'"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-sizes="paginationProps"
      :page-size="pageSize"
      :pager-count="5"
      layout="prev, pager, next, jumper,sizes, total"
      :total="total"
      large
    ></el-pagination>
  </section>
</template>

<script>
  import 'leaflet/dist/leaflet.css';
  import { mapGetters } from 'vuex';
  import NavigationHelper from '@/mixins/navigationHelper';
  import entityRelationshipMixin from '@/mixins/entityRelationshipMixin';
  import CustomDashboardConfig from '@/mixins/CustomDashboardHelper.js';
  import TemplateBuilderhelper from '@/mixins/templateBuilderHelper.js';
  import LayoutDataMixin from '@/mixins/DataFetchingHelper.js';
  import * as XLSX from 'xlsx';
  import AutomationHelper from '@/mixins/AutomationHelper';
  import { isEqual } from '@/helpers/lodashHelper';
  import { postAPICall } from '@/helpers/httpHelper';
  import { addSingleFilterToLocal, updateFilterData, deleteFilter } from '@/repo/filtersRepo';
  import FieldStylesHelper from '../../mixins/FieldStylesHelper';
  import fieldsFormatHelper from '../../mixins/FieldsFormatHelper';
  import { getAllFieldsArrayFromEntity } from '../../utils/formatter';
  export default {
    name: 'EntityDataList',
    components: {
      AddEntityReationshipDataWidget: () =>
        import('./../widgets/AddEntityReationshipDataWidget.vue'),
      EntityContentView: () => import('@/components/widgets/entityViewWidgets/EntityContentView'),
      ActionButtonExecute: () =>
        import('@/components/templates/formComponentsExecute/ActionButtonExecute'),
    },
    mixins: [
      NavigationHelper,
      LayoutDataMixin,
      entityRelationshipMixin,
      CustomDashboardConfig,
      TemplateBuilderhelper,
      AutomationHelper,
      FieldStylesHelper,
      fieldsFormatHelper,
    ],
    data() {
      return {
        isEmailUpdate: false,
        getEntityRecordsForTable: null,
        bulkUploadDocsVisible: false,
        count: 0,
        quickUpdateRowData: null,
        entitybulkDeleteVisible: false,
        is_excelUploaded: false,
        mappedFileName: '',
        mapped_fields: [],
        unmapped_fields: [],
        matchDialogVisible: false,
        is_active: 0,
        uploadedfileDataNames: [],
        existedField: '',
        uploadedFileObject: {},
        selectedRowsIds: [],
        loading: false,
        loadingText: 'Loading...',
        entityDataId: null,
        selectedRelationshipDetails: [],
        showAddRelationshipDataDialog: false,
        quickActionDummyField: null,
        quickActionModal: false,
        quickActionDummyForm: {},
        rowEntityData: {},
        showQrReader: false,
        openExportCSVDialogModal: false,
        selectedTableExcelType: 'ADD_INNER_TABLE',
      };
    },
    computed: {
      ...mapGetters('entities', [
        'getmappedFieldsData',
        'getuploadedFilesData',
        'getentitydataBulkDeleteStatus',
        'getEntitydataBulkDeleteErrors',
        'getEntityDataExportPDFStatus',
      ]),
      ...mapGetters('templatesData', ['getDuplicateDataCheck']),
      ...mapGetters('filters', [
        'getCreateNewFilter',
        'getUpdateFilterStatus',
        'getUpdateFilterData',
        'getDeleteFilterStatus',
        'getCreateNewFilterError',
        'getUpdateFilterError',
        'getDeleteFilterErros',
      ]),
      paginationProps() {
        return [5, 10, 20, 50, 100];
      },
      getMainLabel() {
        if (this.entityFiltersData && this.entityFiltersData.tableFieldGroupBy) {
          return this.getLabel(this.entityFiltersData.tableFieldGroupBy);
        }
        return '';
      },
    },
    async mounted() {
      require('../../assets/css/view-data.scss');
      this.menuTitleLoading = true;
      this.getRequiredKeyValues();
      this.getNecessaryInfo();
      await this.isIframe();
      this.checkRoutekey = this.generateOutputFromUrl(this.$route.fullPath, [
        'key',
        'page',
        'pageSize',
      ]);
      this.$nextTick(() => {
        this.getEntitiesAndTemplates();
      });
    },
    async created() {
      await this.initializeWorkersAndSockets();
    },
    methods: {
      actionType(data) {
        switch (data) {
          case 'BACK_ACTION':
            this.backToEntities();
            return;
          case 'IMPORT_EXCEL':
            this.displayimportdialog();
            return;
          case 'IMPORT_ZIP':
            this.zipImportDialog();
            return;
          case 'IMPORT_DOCS':
            this.bulkUploadDocsVisible = true;
            return;
          case 'EXPORT_EXCEL':
            this.openExportCSVDialog();
            return;
          case 'EXPORT_PDF':
            this.exportPDF();
            return;
          case 'SETTINGS':
            this.openSettingsModal();
            return;
          case 'QR':
            this.showQrReader = true;
            return;
          case 'FILTERS':
            this.openCompanyFilterModel();
            return;
          case 'FILTERS_IFRAME':
            this.openFilterModel();
            return;
          case 'QUICK_FILTERS_OPEN':
            return { title: 'About Page', content: 'Learn more about us here.' };
          case 'QUICK_FILTERS_CLOSE':
            return { title: 'Contact Page', content: 'Get in touch with us!' };
          case 'IFRAME':
            this.ViewConfigPage();
            return;
          case 'LAYOUT':
            this.entityViewModal = true;
            return;
          default:
            return;
        }
      },
      async activeLayout(layout) {
        if (this.activeEntityView !== layout) {
          try {
            this.activeEntityView = layout;

            let query = await this.getNavigationQuery(this.$route.query);
            query['viewType'] = layout;

            await this.$router.push({
              name: this.$route.name,
              query: query,
            });
            let entity = this.currentEntity;
            let params = {
              id: entity._id,
              name: entity.name,
              description: entity.description,
              entity_type: entity.entity_type,
              templates: entity.templates,
              primaryFields: entity.primaryFields,
              settings: entity.settings,
              viewType: layout,
            };
            if (layout == 'HTML_CONTENT' && this.getSelectedEmailTemplate()) {
              params['selected_email_template'] = this.getSelectedEmailTemplate();
              params['columns_per_row'] = this.showFieldsParent.columnsPerRow;
              params['emailView'] = this.showFieldsParent.emailView;
            }
            await this.$store.dispatch('entities/updateEntityById', params);
            if (layout == 'HTML_CONTENT') this.fetchEntitiesDataForTable([]);
          } catch (error) {
            console.error('Error updating layout:', error);
          }
        }
      },
      async getNecessaryInfo() {
        await this.getRequiredData();
      },
      openExportCSVDialog() {
        let isTablePresent = this.allEntityFields.some(
          (field) => field.input_type === 'ENTITY_TABLE' || field.input_type === 'DATA_TABLE'
        );
        if (isTablePresent) {
          this.openExportCSVDialogModal = true;
        } else {
          this.exportCSV();
        }
      },
      refreshCurrentPage() {
        this.fetchEntitiesDataForTable();
      },
      removeKeyListener() {
        document.removeEventListener('keydown', this.handleKeyDown);
      },
      handleQuickUpdateData(data) {
        this.isEmailUpdate = true;
        this.quickUpdateRowData = {
          ...data,
        };
      },
      handleKeyDown(event) {
        if (event.key === 'Enter') {
          this.deleteCheckedEntityData();
        }
      },
      async updateRow(row) {
        this.loading = true;
        await Promise.all(
          this.currentEntity?.templates.map(async (temp) => {
            const hasQuickUpdateData =
              this.quickUpdateRowData[temp.template_id] &&
              typeof this.quickUpdateRowData[temp.template_id] === 'object' &&
              !Object.values(this.quickUpdateRowData[temp.template_id]).every(
                (value) => value == null || value === ''
              );

            if (
              (hasQuickUpdateData &&
                !isEqual(
                  row.entityData[temp.template_id],
                  this.quickUpdateRowData[temp.template_id]
                )) ||
              this.isEmailUpdate
            ) {
              this.loadingText = 'Checking duplicate data...';
              await this.$store.dispatch('templatesData/checkDuplicateData', {
                data: [
                  {
                    form: this.quickUpdateRowData[temp.template_id],
                    template_id: temp.template_id,
                  },
                ],
                entity_id: this.entity_id,
                parent_entityDataId: row._id || null,
              });
              if (this.getDuplicateDataCheck && !this.getDuplicateDataCheck?.allowed) {
                this.$notify.warning({
                  title: 'Warning',
                  message: 'Duplicate data found',
                });
                this.loading = false;
                this.loadingText = 'Loading...';
                return;
              }
              this.loadingText = 'Updating data...';
              const params = {
                template_data: this.quickUpdateRowData[temp.template_id],
                entity_data_id: row._id,
                template_id: temp.template_id,
                entity_id: this.entity_id,
                ignore_tables: true,
              };
              const response = await postAPICall(
                'PATCH',
                `templates-data/${params.entity_data_id}/${params.template_id}`,
                params
              );
              await this.updateRelationshipsData(
                response.updated_data,
                temp.templateInfo,
                this.relationshipsData
              );
            }
          })
        );
        this.quickUpdateIndex = -1;
        this.loading = false;
        await this.fetchEntitiesDataForTable();
      },
      async checkForFilterUpdate() {
        this.entityViewModal = false;
        this.filterColumList = this.filterColumList.filter((e) => e.id && e.template_id);
        if (this.isApplicationUserSide) {
          let data = this.getEntityShowFields || {};
          if (data) {
            data[this.currentEntity._id] = { ...this.showFieldsParent };
          }
          await this.$store.commit('entities/setEntityShowFields', data, {
            root: true,
          });
        } else if (this.currentFilter) {
          await this.$store.dispatch('filters/updateFilter', {
            id: this.currentFilter,
            params: {
              columns_settings: this.filterColumList,
              email_template_id: this.getSelectedEmailTemplate(),
            },
          });
        } else {
          await this.$store.dispatch('entities/updateEntityById', {
            settings: this.filterColumList,
            name: this.currentEntity.name,
            description: this.currentEntity.description,
            entity_type: this.currentEntity.entity_type,
            templates: this.currentEntity.templates,
            id: this.currentEntity._id,
            primaryFields: this.currentEntity.primaryFields,
            views_configuration: this.showFieldsParent,
            viewType: this.activeLayout,
          });
        }
      },
      downloadExcelFromJson(csvData, fileName) {
        const worksheet = XLSX.utils.json_to_sheet(csvData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        const excelBuffer = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array',
        });
        const blob = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);

        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 0);
      },
      downloadExcelFile() {
        let templateFields = [];
        if (this.current_entity_tempates) {
          this.current_entity_tempates.forEach((temp) => {
            if (temp && temp.is_repeatable === false) {
              if (temp.sections && temp.sections[0] && temp.sections[0].fields) {
                temp.sections[0].fields.forEach((fi) => {
                  templateFields.push(fi.label);
                });
              }
            }
          });
        }
        this.gotoDownload(templateFields);
      },
      clearImportData() {
        this.mapped_fields = [];
        this.unmapped_fields = [];
        this.getmappedFieldsData = [];
        this.uploadedFileObject = null;
        this.is_excelUploaded = false;
        this.is_active = 0;
        this.mappedFileName = '';
        this.existedField = '';
        this.matchDialogVisible = true;
      },
      async displayimportdialog() {
        let params = {
          id: this.entity_id,
        };
        this.loading = true;
        await this.$store.dispatch('entities/getuploadedFiles', params);
        if (this.getuploadedFilesData && this.getuploadedFilesData.data) {
          this.uploadedfileDataNames = this.getuploadedFilesData.data;
        }
        this.clearImportData();
        this.loading = false;
      },
      async downloadGroupbyData() {
        let filters = this.applied_filters;
        if (this.currentMenu?.entity_type == 'RELATIONAL_ENTITY' && this.isApplicationUserSide) {
          filters = [...filters, ...this.getSelfEntityFilters];
        }
        if (!this.entityFiltersData && this.$route.query.filter) {
          this.resetEntityFiltersData();
        }
        filters = [...this.entityFiltersData.filters, ...filters];
        this.exportFilters = filters;
        let checkDataTable = this.filterColumList.find((e) => e.type == 'DATA_TABLE');
        let params = {
          entity_id: this.entity_id,
          template_fields_data: getAllFieldsArrayFromEntity(this.currentEntity),
          format_data: true,
          filters: this.mapDateFilters(
            this.addGlobalFilters(filters || [], this.entity_id, this.checkGlobalFilter)
          ),
          sortBy: this.sortBy,
          sortOrder: this.sortOrder,
          search_string: this.search_string,
          data_table_field: checkDataTable,
        };
        if (this.entityFiltersData?.tableFieldGroupBy) {
          let subField = this.getField(this.entityFiltersData.tableFieldGroupBy);
          if (subField?.inputType == 'MULTI_SELECT') {
            params.unwind = true;
          }
          params.group_by = this.entityFiltersData.tableFieldGroupBy;
          params.group_by_fields = this.entityFiltersData.tableFieldGroupByFields;
          if (this.entityFiltersData?.tableFieldSubGroupBy) {
            params.sub_group_by = this.entityFiltersData?.tableFieldSubGroupBy;
          } else {
            params.entity_variable_columns = this.entityFiltersData.filterEntityVariableColumns;
            if (this.getField(this.entityFiltersData.tableFieldGroupBy)?.entity_id) {
              params.filter_variable_entity = this.getField(
                this.entityFiltersData.tableFieldGroupBy
              ).entity_id;
            }
          }
        }
        const v2Response = await postAPICall('POST', '/entities-data/entity/data/v2', params);
        this.entityRecordsForTableLocal = v2Response?.data;
        let groupedData = [],
          csvData = [];
        if (this.entityFiltersData?.tableFieldGroupBy) {
          if (this.entityFiltersData?.tableFieldSubGroupBy) {
            let custom_columns = [];
            groupedData = this.entityRecordsForTableLocal.data.map((data) => {
              if (data?.properties) {
                let label = '',
                  total = 0;
                (data.properties || []).forEach((el) => {
                  if (!label) {
                    label = el.entity_label;
                  }
                  total = total + el.count;
                  let value = el.sub_entity_label ? el.sub_entity_label : el.label;
                  let index = custom_columns.findIndex((e) => e.value == el.label);
                  if (index == -1 && value) {
                    custom_columns.push({
                      value: el.label,
                      label: value,
                    });
                  }
                  (Object.keys(el) || []).forEach((key) => {
                    if (['entity_label', 'label', 'sub_entity_label'].indexOf(key) == -1) {
                      data[el.label + '?' + key] = el[key];
                      data[value + '?' + key] = el[key];
                    }
                  });
                });

                data.entity_label = label;
                data.count = total;
              }
              return data;
            });
            if (
              this.entityFiltersData?.table_field_group_by_selected_options &&
              this.entityFiltersData.table_field_group_by_selected_options.length
            ) {
              custom_columns = custom_columns.filter(
                (e) =>
                  this.entityFiltersData.table_field_group_by_selected_options.indexOf(e.value) !=
                  -1
              );
            }
            this.entityFiltersData.tableFieldGroupByFields
              .filter((e) => e.sub_group)
              .forEach((field) => {
                (custom_columns || []).forEach((col) => {
                  this.custom_columns.push({
                    label: col.label + '-' + field.name,
                    value: col.value + '?' + field.key,
                  });
                });
              });
          } else {
            groupedData = this.entityRecordsForTableLocal.data;
            groupedData = this.groupedData.map((e) => {
              if (e && e.name && e.name.includes('#')) {
                e.name = e.name.split('#')[0];
              }
              return e;
            });
          }
        }
        groupedData.forEach((data) => {
          let obj = {};
          obj[this.getMainLabel] = data.entity_label ? data.entity_label : data._id;
          this.entityFiltersData.tableFieldGroupByFields
            .filter((e) => !e.sub_group)
            .forEach((step) => {
              obj[step.name] = data[step.key];
            });
          this.custom_columns.forEach((step) => {
            obj[step.label] = this.getSubField(data, step.value);
          });
          csvData.push(obj);
        });
        this.downloadExcelFromJson(csvData, 'ExcelData');
      },
      async exportCSV() {
        this.openExportCSVDialogModal = false;
        if (this.entityFiltersData.tableFieldGroupBy) {
          await this.downloadGroupbyData();
          return;
        }
        let params = {
          id: this.entity_id,
          entityName: this.currentEntity.name,
          filters: this.mapDateFilters(this.exportFilters || []),
          dataIds: this.exportDataIds,
          selectedFilter: this.currentFilter,
          selectedExcelTypeForTables: this.selectedTableExcelType,
        };
        this.loadingText = 'Generating Excel...';
        this.loading = true;
        await this.$store.dispatch('entities/entityDataExport', params);
        this.loading = false;
        this.loadingText = 'Loading...';
      },
      async exportPDF() {
        let params = {
          id: this.entity_id,
          entityName: this.currentEntity.name,
          filters: this.mapDateFilters(this.exportFilters || []),
          selectedFilter: this.currentFilter,
          dataIds: this.exportDataIds,
          document_id: this.currentEntity?.export_printing_document,
        };
        this.loading = true;
        this.loadingText = 'Generating PDF...';
        await this.$store.dispatch('entities/entityDataExportPDF', params);
        if (
          this.getEntityDataExportPDFStatus &&
          this.getEntityDataExportPDFStatus.success &&
          this.getEntityDataExportPDFStatus.data.length
        ) {
          await this.downloadEntityDataPdf(
            this.getEntityDataExportPDFStatus.data[0],
            this.currentEntity?.name
          );
        } else {
          this.$notify.error({
            title: 'Error',
            message: 'Error while generating Document',
          });
        }
        this.loading = false;
        this.loadingText = 'Loading...';
      },
      async deleteCheckedEntityData() {
        let selectedIds = [];
        this.selectedRowsIds.forEach((item) => {
          if (item && item._id) {
            selectedIds.push(item._id);
          }
        });
        this.count = selectedIds.length;
        let params = {
          selectedIds: selectedIds,
          entity_id: this.entity_id,
        };
        this.entitybulkDeleteVisible = false;
        this.loading = true;
        await this.$store.dispatch('entities/entitydataBulkDelete', params);
        if (this.getentitydataBulkDeleteStatus && this.getentitydataBulkDeleteStatus.message) {
          this.fetchEntitiesDataForTable();
          this.selectedRowsIds = [];
          this.$notify.success({
            title: 'Success',
            message: this.getentitydataBulkDeleteStatus.message,
          });
          this.loading = false;
        } else {
          let message = 'Error in deleting data';
          if (this.getEntitydataBulkDeleteErrors) {
            message = this.getEntitydataBulkDeleteErrors;
          }
          this.loading = false;
          this.$notify.error({
            title: 'Error',
            message: message,
          });
        }
      },
      getSubField(data, step) {
        let value = 0,
          key = step && step.includes('?') ? step.split('?')[1] : step;
        let field = this.getField(key);
        if (data && step && data[step]) {
          value = data[step];
        }
        if (field?.inputType == 'CURRENCY') {
          let type = field.validations.currency ? field.validations.currency : 'USD';
          let locale = field.validations.locale ? field.validations.locale : 'en-US';
          value = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: type,
          }).format(value);
        } else if (field?.inputType == 'AGGREGATE_FUNCTION') {
          let isCurrencyField = (field.selected_fields || []).find((el) => {
            if (el?.inputType == 'CURRENCY' || el?.result_type == 'CURRENCY') {
              return true;
            }
          });
          if (isCurrencyField) {
            let type =
              isCurrencyField && isCurrencyField.validations && isCurrencyField.validations.currency
                ? isCurrencyField.validations.currency
                : 'USD';
            let locale =
              isCurrencyField && isCurrencyField.validations && isCurrencyField.validations.locale
                ? isCurrencyField.validations.locale
                : 'en-US';
            value = new Intl.NumberFormat(locale, {
              style: 'currency',
              currency: type,
            }).format(value);
          } else {
            return value;
          }
        }
        return value;
      },
      async deleteFilter() {
        let id = this.entityFiltersData._id ? this.entityFiltersData._id : '';
        if (!id) {
          this.$notify({
            title: 'Error',
            message: 'Filter not selected',
            type: 'error',
          });
          return;
        }
        this.loading = true;
        await this.$store.dispatch('filters/deleteFilter', id);
        if (this.getDeleteFilterStatus) {
          await deleteFilter(id);
          this.dialogEdit = false;
          this.resetEntityFiltersData();
          if (this.$route.query.routeType) {
            this.UsercurrentFilter = '';
          }
          this.currentFilter = '';
          this.loading = false;
          this.$notify({
            title: 'Success',
            message: 'Filters deleted',
            type: 'success',
          });
          this.loading = false;
          this.fetchAllEntityFilters();
          this.fetchEntitiesDataForTable();
        } else {
          this.loading = false;
          let msg = 'Failed to delete the filters';
          if (this.getDeleteFilterErros?.message) {
            msg = this.getDeleteFilterErros.message;
          }
          this.$notify({
            title: 'Error',
            message: msg,
            type: 'error',
          });
        }
      },
      async updateFilter() {
        let params = this.prepareFilterParams();
        if (!params.filter_name) {
          this.$notify({
            title: 'Error',
            message: 'Please enter Filter name',
            type: 'error',
          });
          return;
        }
        let id = this.entityFiltersData._id ? this.entityFiltersData._id : '';
        if (!id) {
          await this.saveFilter();
        }
        await this.$store.dispatch('filters/updateFilter', {
          id: id,
          params: params,
        });
        if (this.getUpdateFilterStatus) {
          if (this.getUpdateFilterData?.data) {
            await updateFilterData(id, this.getUpdateFilterData.data);
          }
          this.$notify({
            title: 'Success',
            message: 'Filters updated',
            type: 'success',
          });
          this.loading = true;
          await this.fetchAllEntityFilters();
          this.loading = false;
        } else {
          this.loading = false;
          let msg = 'Failed to Save the filters';
          if (this.getUpdateFilterError && this.getUpdateFilterError.message) {
            msg = this.getUpdateFilterError.message;
          }
          this.$notify({
            title: 'Error',
            message: msg,
            type: 'error',
          });
        }
      },
      prepareFilterParams() {
        return {
          filter_name: this.entityFiltersData.filter_name.trim(),
          filters: this.entityFiltersData.filters,
          sortBy: this.entityFiltersData.sortBy,
          sortOrder: this.entityFiltersData.sortOrder,
          entity_id: this.entity_id,
          quick_filters: this.entityFiltersData.quick_filters,
          permissions: this.entityFiltersData.permissions,
          tableFieldGroupBy: this.entityFiltersData.tableFieldGroupBy || '',
          tableFieldSubGroupBy: this.entityFiltersData.tableFieldSubGroupBy || '',
          tableFieldGroupByFields: this.entityFiltersData.tableFieldGroupByFields || [],
          filterEntityVariableColumns: this.entityFiltersData.filterEntityVariableColumns,
          displayType: this.entityFiltersData.displayType,
          data_limit: this.entityFiltersData.data_limit,
          email_template_id: this.getSelectedEmailTemplate(),
          ...(this.$route.query.routeType && {
            filter_name: this.entityUserFiltersData.filter_name.trim(),
            parent_filter_id: this.entityUserFiltersData.parentFilterId,
            role_id: this.getAuthenticatedUser.activeRole.role_id,
          }),
        };
      },
      async saveFilter() {
        let params = this.prepareFilterParams();
        if (!params.filter_name) {
          this.$notify({
            title: 'Error',
            message: 'Please enter Filter name',
            type: 'error',
          });
          return;
        }
        await this.$store.dispatch('filters/fetchCreateNewFilter', params);
        if (this.getCreateNewFilter) {
          this.showFieldsParent.selectedFilter = [this.getCreateNewFilter._id];
          if (this.$route.query.routeType) {
            this.UsercurrentFilter = this.getCreateNewFilter._id;
          }
          this.currentFilter = this.getCreateNewFilter._id;
          await addSingleFilterToLocal(this.getCreateNewFilter);
          this.$notify({
            title: 'Success',
            message: 'Filters saved',
            type: 'success',
          });
          this.loading = true;
          await this.fetchAllEntityFilters();
          this.loading = false;
        } else {
          this.loading = false;
          let msg = 'Filter name already exists';
          if (this.getCreateNewFilterError && this.getCreateNewFilterError.message) {
            msg = this.getCreateNewFilterError.message;
          }
          this.$notify({
            title: 'Error',
            message: msg,
            type: 'error',
          });
        }
      },
      async handleSizeChange(val) {
        this.pageSize = val;
        this.fetchEntitiesDataForTable(this.applied_quick_filters, true);
        await this.$store.dispatch('entities/updatePageSizeNumber', this.pageSize);
        const query = this.$route.query;
        this.$router.push({ query: { ...query, pageSize: val } });
      },
      async handleCurrentChange(val) {
        this.fetchEntitiesDataForTable(this.applied_quick_filters, true);
        const query = this.$route.query;
        this.$router.push({ query: { ...query, page: val } });
      },
    },
    async beforeDestroy() {
      this.removeKeyListener();
      this.resetStore();
      await this.terminateWorkers();
    },
  };
</script>
